import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">热门推荐</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">精选各频道最受欢迎的影视内容，每日更新推荐</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cardItems.map((item) => (
            <article key={item.id} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer">
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-black/50 backdrop-blur-sm text-white text-xs rounded-full whitespace-nowrap">
                    {item.views} 次播放
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">{item.desc}</p>
                <div className="flex flex-wrap gap-1.5">
                  {item.tags.map((tag) => (
                    <span key={tag} className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full whitespace-nowrap">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}